import styled from "styled-components";
import { colors } from "../../consts";

import { Paragraph2 } from "../Text/Paragraphs";
import WrapperContainer from "../Containers/WrapperContainer";

export const Label = styled(Paragraph2)`
  font-size: 14px;
  line-height: 24px;
  font-weight: 500;
`;

export const RadioInputWrapper = styled(WrapperContainer)`
  padding: 16px;

  border: 1px solid;
  border-radius: 16px;

  border-color: ${(props) => (props?.isSelected ? colors.RAISIN_100 : "transparent")};
  transition: border 0.3s;

  cursor: pointer;
`;
